var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import HTTP from "@/http";
import MenuAddToPlaylistItem from "./MenuAddToPlaylistItem";
import snackbarBus from "@/snackbarBus";
import Validate from "@/decorators/validate";
var MenuAddToPlaylist = (function (_super) {
    __extends(MenuAddToPlaylist, _super);
    function MenuAddToPlaylist() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.creatingPlaylist = false;
        _this.playlists = [];
        _this.form = {
            title: '',
            visibility: 'private',
        };
        return _this;
    }
    MenuAddToPlaylist.prototype.onPlaylistsChanged = function () {
        this.playlists = this.$store.state.user.user.playlists;
    };
    MenuAddToPlaylist.prototype.onMenuToggle = function (val) {
        var _this = this;
        if (val) {
            this.playlists = [];
            this.$store.dispatch("getUserPlaylists").then(function (r) {
                _this.$nextTick(function () {
                    _this.playlists = _this.$store.state.user.user.playlists;
                });
            });
        }
    };
    MenuAddToPlaylist.prototype.submit = function () {
        var _this = this;
        var params = this["$deepcopy"](this.form);
        params.audioId = this.audio.id;
        this.$refs.btnSubmit["$el"].disabled = "disabled";
        HTTP.post("/playlists", params)
            .then(function (response) {
            _this.$refs.btnSubmit["$el"].disabled = null;
            snackbarBus.$emit("show", "Added to new playlist");
            _this.form = {
                title: "",
                visibility: "private",
            };
            _this.creatingPlaylist = false;
            _this.$store.dispatch("getUserPlaylists");
        })
            .catch(function (error) {
            _this.$refs.btnSubmit["$el"].disabled = null;
            snackbarBus.$emit("show", "There was an error. Try again");
        });
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], MenuAddToPlaylist.prototype, "audio", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], MenuAddToPlaylist.prototype, "value", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], MenuAddToPlaylist.prototype, "activator", void 0);
    __decorate([
        Watch("$store.state.user.user.playlists", { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuAddToPlaylist.prototype, "onPlaylistsChanged", null);
    __decorate([
        Watch("value"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MenuAddToPlaylist.prototype, "onMenuToggle", null);
    __decorate([
        Validate,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuAddToPlaylist.prototype, "submit", null);
    MenuAddToPlaylist = __decorate([
        Component({
            components: {
                'playlist': MenuAddToPlaylistItem,
            },
        })
    ], MenuAddToPlaylist);
    return MenuAddToPlaylist;
}(Vue));
export default MenuAddToPlaylist;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/MenuAddToPlaylist.vue
// module id = 224
// module chunks = 0